"use strict";
// Copyright 2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
var PresentationBoxType;
(function (PresentationBoxType) {
    PresentationBoxType[PresentationBoxType["LETTER_BOX"] = 0] = "LETTER_BOX";
    PresentationBoxType[PresentationBoxType["PILLAR_BOX"] = 1] = "PILLAR_BOX";
    PresentationBoxType[PresentationBoxType["NONE"] = 2] = "NONE";
})(PresentationBoxType || (PresentationBoxType = {}));
exports.default = PresentationBoxType;
//# sourceMappingURL=PresentationBoxType.js.map